module.exports = __webpack_public_path__ + "static/media/some-luna-noah-nologo.aaf910ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Spill/static/some-luna-noah-nologo.png
// module id = 184
// module chunks = 0